import React, { useEffect, useState } from 'react'
import "./ContributionSection.scss";
import "../Auth/AuthCommLink.scss";

import { useDraggableSheet } from '../../../helpers/hooks';
import Icon from '../../components/Icon';
import { useDispatch, useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';
import { supabase } from '../../../supabase';
import { completeSignupPassword, getUserById, login, sendInviteFromSoftwall, setSessionUser, setUser, softwallSignupAndLogin } from '../../Reducers/actions/authActions';
import { validateEmail, validateUsername, getUsernameValidationMessage } from '../../../helpers/utilities';
import { startGoogleAuth } from '../Auth/googleAuth';
import GoogleButtonContent from '../Auth/GoogleButtonContent';
import { fetchVerifyInvite } from '../../Reducers/actions/userActions';
import { resumePendingContributionCheckout } from '../../../helpers/resumeContributionCheckout';
import {
    clearPasswordSetupPending,
    markPasswordSetupPending,
    isPasswordSetupPending,
    VERIFY_EMAIL_BANNER_EMAIL_KEY,
    clearPendingSoftwallInvite,
    readPendingContributionIntent,
    resolveCreatorFromInvite,
    resolveUsernameFromInvite,
    savePendingSoftwallInvite,
    SIGNUP_CREATOR_SESSION_KEY,
} from '../../constants/signupFlow';
const latestOnBoardingVersion = 0 //in case at some point we want to show our user some app downloads or other boarding pages 

function GoogleMarkIcon() {
    return (
        <svg width="24" height="24" viewBox="0 0 24 24" aria-hidden="true">
            <path
                fill="#4285F4"
                d="M23.49 12.27c0-.79-.07-1.55-.2-2.27H12v4.3h6.44a5.5 5.5 0 0 1-2.39 3.6v2.99h3.86c2.26-2.08 3.58-5.16 3.58-8.62Z"
            />
            <path
                fill="#34A853"
                d="M12 24c3.24 0 5.96-1.07 7.95-2.91l-3.86-2.99c-1.07.72-2.44 1.14-4.09 1.14-3.14 0-5.8-2.12-6.75-4.97H1.27v3.08A12 12 0 0 0 12 24Z"
            />
            <path
                fill="#FBBC05"
                d="M5.25 14.27A7.2 7.2 0 0 1 4.87 12c0-.79.14-1.56.38-2.27V6.65H1.27A12 12 0 0 0 0 12c0 1.94.47 3.78 1.27 5.35l3.98-3.08Z"
            />
            <path
                fill="#EA4335"
                d="M12 4.77c1.76 0 3.34.61 4.59 1.81l3.44-3.44C17.95 1.2 15.23 0 12 0A12 12 0 0 0 1.27 6.65l3.98 3.08c.95-2.86 3.61-4.96 6.75-4.96Z"
            />
        </svg>
    );
}

function SoftWallModal({ open, onClose, onKeepOpenAfterAuthChange, title="Sign up or log in to continue using HYK", initialMode="login", signupToken = null, signupCode = null }) {
    const getStripeSessionData = (response) => {
        const sessionId =
            response?.id ||
            response?.sessionId ||
            response?.session_id ||
            response?.data?.id ||
            response?.data?.sessionId ||
            response?.data?.session_id;
        const sessionUrl =
            response?.url ||
            response?.checkout_url ||
            response?.data?.url ||
            response?.data?.checkout_url;
        return { sessionId, sessionUrl };
    };

    const {
        sheetStyle,
        overlayHandlers,
    } = useDraggableSheet({ onClose, lockBodyScroll: open });

    const OnBoardingVersion = useSelector((state) => state.auth?.user?.onboarding_version)
    const authUser = useSelector((state) => state.auth?.user)

    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [loadingLogin, setLoadingLogin] = useState(false)
    const [loadingSignup, setLoadingSignup] = useState(false)
    const [loadingGoogle, setLoadingGoogle] = useState(false)
    const [showPwd, setShowPwd] = useState(false)
    const [authMode, setAuthMode] = useState(initialMode);
    // const [toastMessage, setToastMessage] = useState("");
    const [errorMessage, setErrorMessage] = useState(null);
    const [errorMessageSignup, setErrorMessageSignup] = useState(null);

    /** Signup flow: form → verify-email */
    const [signupView, setSignupView] = useState("form");
    const [signupUsername, setSignupUsername] = useState("");
    const [signupEmail, setSignupEmail] = useState("");
    /** @type {'creator' | 'fan' | null} */
    const [signupRole, setSignupRole] = useState(null);
    const [pendingVerifyEmail, setPendingVerifyEmail] = useState("");
    const [verifyEmailMessage, setVerifyEmailMessage] = useState(null);
    const [inviteLoading, setInviteLoading] = useState(false);
    const [inviteEmail, setInviteEmail] = useState("");
    const [inviteUsername, setInviteUsername] = useState("");
    const [pwdConfirm, setPwdConfirm] = useState("");
    const dispatch = useDispatch()
    // const [toastType, setToastType] = useState("toast-info");
    const navigate = useNavigate();
    const location = useLocation();
    const validateForm = () => {
        // const newErrors = {};
        const BreakException = {}
        try {
            if (!(email && email.length > 0 && (validateEmail(email) || validateUsername(email)))) {
                setErrorMessage("Email is required.")
                setErrorMessageSignup("Email is required.")
                throw BreakException
            }

            if (!(password && password.length > 0)) {
                setErrorMessage("Password is required.")
                throw BreakException
            }

            const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/
            if (password && !passwordRegex.test(password)) {
                setErrorMessage("Password must be at least 8 characters long, with at least 1 uppercase, 1 lowercase, and 1 special character.")
                throw BreakException
            }
            setErrorMessage(null)
            setErrorMessageSignup(null)
        } catch (e) {
            if (e !== BreakException) console.log(e)
        }
    };

    useEffect(() => {
        const checkUser = async () => {
            const { data } = await supabase.auth.getSession();
            if (data.session && data.session) {
                dispatch(setSessionUser(data.session));
            }
        };
        checkUser();
    }, [dispatch]);

    // Update authMode when initialMode changes (e.g., when opened from signup button)
    useEffect(() => {
        if (open) {
            setAuthMode(initialMode);
        }
    }, [open, initialMode]);

    useEffect(() => {
        if (!open) {
            setSignupView("form");
            setSignupUsername("");
            setSignupEmail("");
            setSignupRole(null);
            setPendingVerifyEmail("");
            setVerifyEmailMessage(null);
            setInviteLoading(false);
            setInviteEmail("");
            setInviteUsername("");
            setPwdConfirm("");
        }
    }, [open]);

    useEffect(() => {
        if (!open || authMode !== "verify-email") return;
        const fromQuery = new URLSearchParams(window.location.search).get("verifyEmail");
        if (fromQuery) {
            setPendingVerifyEmail(fromQuery);
            return;
        }
        try {
            const storedEmail = localStorage.getItem(VERIFY_EMAIL_BANNER_EMAIL_KEY);
            if (storedEmail) setPendingVerifyEmail(storedEmail);
        } catch {
            // ignore
        }
    }, [open, authMode]);

    useEffect(() => {
        if (!open || authMode !== "complete-signup") return;
        if (!signupToken) {
            setErrorMessageSignup("Invite link is invalid.");
            return;
        }
        setInviteLoading(true);
        setErrorMessageSignup(null);
        fetchVerifyInvite(signupToken, signupCode || null).then(({ success, message, data }) => {
            if (!success) {
                setErrorMessageSignup(message || "Invite link is invalid or expired.");
                setInviteLoading(false);
                return;
            }

            const emailFromInvite = data?.email || "";
            setInviteEmail(emailFromInvite);
            const resolvedUsername = resolveUsernameFromInvite(data, new URLSearchParams(window.location.search));
            if (resolvedUsername) setInviteUsername(resolvedUsername.toUpperCase());

            const creator = resolveCreatorFromInvite(data, new URLSearchParams(window.location.search));
            sessionStorage.setItem(SIGNUP_CREATOR_SESSION_KEY, creator ? "1" : "0");
            setInviteLoading(false);
        });
    }, [open, authMode, signupToken, signupCode]);
    // useEffect(() => {
    //     setError(null)
    //     validateForm()
    // }, [email, password, validateForm])

    // Monitor for auto-fill changes
   

    const validateSoftwallSignup = () => {
        const u = (signupUsername || "").trim().toUpperCase();
        const userMsg = getUsernameValidationMessage(u);
        if (userMsg) {
            setErrorMessageSignup(userMsg);
            return false;
        }
        if (!(signupEmail && signupEmail.length > 0 && validateEmail(signupEmail.trim()))) {
            setErrorMessageSignup("Please enter a valid email address.");
            return false;
        }
        if (!signupRole) {
            setErrorMessageSignup("Please choose how you want to use HYK.");
            return false;
        }
        setErrorMessageSignup(null);
        return true;
    };

    const buildInvitePayload = () => {
        const email =
            signupEmail.trim() || pendingVerifyEmail.trim() || (authUser?.email || "").trim();
        const username =
            (signupUsername || "").trim().toUpperCase() ||
            (authUser?.userName || "").trim().toUpperCase();
        const is_creator =
            signupRole === "creator"
                ? true
                : signupRole === "fan"
                  ? false
                  : authUser?.role === "creator";
        return { email, username, is_creator };
    };

    const handleSignup = async (e) => {
        e.preventDefault();
        if (!validateSoftwallSignup()) return;
        setErrorMessageSignup(null);
        setLoadingSignup(true);
        try {
            const { success, message, data } = await softwallSignupAndLogin(buildInvitePayload());
            if (success) {
                if (!data?.session?.access_token || !data?.session?.refresh_token) {
                    setErrorMessageSignup("Signup completed but session was not created.");
                    return;
                }

                onKeepOpenAfterAuthChange?.(true);
                dispatch(setSessionUser(data.session));
                await supabase.auth.setSession({
                    access_token: data.session.access_token,
                    refresh_token: data.session.refresh_token,
                });
                clearPendingSoftwallInvite();
                try {
                    localStorage.setItem(VERIFY_EMAIL_BANNER_EMAIL_KEY, signupEmail.trim());
                    if (data?.requires_password_setup) {
                        markPasswordSetupPending(signupEmail.trim());
                    }
                } catch {
                    // ignore storage errors
                }
                setPendingVerifyEmail(signupEmail.trim());
                setVerifyEmailMessage({
                    title: "Account created",
                    body: "A temporary password has been created for your account. You will receive an email shortly with a link to set your password and complete your signup.",
                });
                setSignupView("verify-email");
                setAuthMode("verify-email");
                return;
            }
            if (message?.includes?.("already registered")) {
                setAuthMode("login");
                setErrorMessage(message);
                setErrorMessageSignup(message);
                return;
            }
            setErrorMessageSignup(message || "Something went wrong. Please try again.");
        } catch (error) {
            console.error("Softwall signup invite failed:", error);
            setErrorMessageSignup(error?.message || "Something went wrong. Please try again.");
        } finally {
            setLoadingSignup(false);
        }
    };

    const handleResendInvite = async () => {
        setErrorMessageSignup(null);
        setLoadingSignup(true);
        try {
            const payload = buildInvitePayload();
            const { success, message } = await sendInviteFromSoftwall(payload);
            if (success) {
                savePendingSoftwallInvite({
                    email: payload.email,
                    username: payload.username,
                    is_creator: payload.is_creator,
                });
            } else {
                setErrorMessageSignup(message || "Could not resend. Try again later.");
            }
        } catch (error) {
            console.error("Resend invite failed:", error);
            setErrorMessageSignup(error?.message || "Could not resend. Try again later.");
        } finally {
            setLoadingSignup(false);
        }
    };

    const handleChangeEmailClick = () => {
        setSignupView("form");
        setErrorMessageSignup(null);
    };

    const showEmailField = (signupUsername || "").trim().length > 0;
    const showRoleButtons = (signupEmail || "").trim().length > 0;
    const shouldShowPasswordSetupCopy =
        !!pendingVerifyEmail?.trim() && isPasswordSetupPending(pendingVerifyEmail);
    const verifyEmailTitle =
        verifyEmailMessage?.title ||
        (shouldShowPasswordSetupCopy
            ? "Check your email to set your password"
            : "Verify your email address");
    const verifyEmailBody =
        verifyEmailMessage?.body ||
        (shouldShowPasswordSetupCopy
            ? `We sent an email to ${pendingVerifyEmail}. Tap the link in the email to set your password and continue.`
            : `We sent an email to ${pendingVerifyEmail}. Tap the link in the email to confirm your address and continue.`);
    const showVerifyEmailActions = !verifyEmailMessage;
    const handleCloseAuthModal = () => {
        void (async () => {
            const pendingIntent = readPendingContributionIntent();
            const isDigitalOrderIntent =
                pendingIntent?.source === "order" &&
                pendingIntent?.creation?.creation_type &&
                String(pendingIntent.creation.creation_type).toLowerCase().includes("digital");
            const canTryCheckout =
                (pendingIntent?.source === "contribute" || isDigitalOrderIntent) &&
                Number(pendingIntent?.amount) > 0;

            if (canTryCheckout) {
                const {
                    data: { session },
                } = await supabase.auth.getSession();
                if (session) {
                    onKeepOpenAfterAuthChange?.(false);
                    onClose();
                    const result = await resumePendingContributionCheckout({
                        intent: pendingIntent,
                    });
                    if (result?.success && result?.redirecting) {
                        return;
                    }
                    window.dispatchEvent(
                        new CustomEvent("hyk:resume-contribution", {
                            detail: pendingIntent,
                        }),
                    );
                    return;
                }
            }

            onKeepOpenAfterAuthChange?.(false);
            onClose();
        })();
    };

    const handleLogin = async (e) => {
        validateForm();
        if (errorMessage) {
            setLoadingLogin(false)

            return
        }
        e.preventDefault();
        setLoadingLogin(true);
        login({ email, password }).then(async ({ success, data, message }) => {
            if (success && data && data.session) {
                dispatch(setSessionUser(data.session))
                await supabase.auth.setSession({
                    access_token: data.session.access_token,
                    refresh_token: data.session.refresh_token,
                });
                clearPasswordSetupPending(email);
                // if (data.user) {
                //     dispatch(setUser(data.user))
                // }

                setLoadingLogin(false);

                const pendingContribute = readPendingContributionIntent();
                const isDigitalOrderIntent =
                    pendingContribute?.source === "order" &&
                    pendingContribute?.creation?.creation_type &&
                    String(pendingContribute.creation.creation_type).toLowerCase().includes("digital");
                if (
                    (pendingContribute?.source === "contribute" || isDigitalOrderIntent) &&
                    Number(pendingContribute?.amount) > 0
                ) {
                    onKeepOpenAfterAuthChange?.(false);
                    onClose();
                    try {
                        getUserById(data?.session?.user?.id).then(({ success: ok, data: profile }) => {
                            if (ok && profile) {
                                dispatch(setUser(profile));
                                if (profile?.profilePicture) {
                                    localStorage.setItem("pdp", profile.profilePicture);
                                }
                            }
                        });
                    } catch (err) {
                        console.error("Error fetching user:", err);
                    }
                    const checkout = await resumePendingContributionCheckout({
                        intent: pendingContribute,
                    });
                    if (checkout?.success && checkout?.redirecting) {
                        return;
                    }
                    window.dispatchEvent(
                        new CustomEvent("hyk:resume-contribution", {
                            detail: pendingContribute,
                        }),
                    );
                    return;
                }

                // For new users without last_sign_in_at, redirect to complete profile
                if (!data?.user?.last_sign_in_at) {
                    navigate('/add-social-links');
                    return;
                }

                // For returning users with onboarding incomplete
                if (data?.user?.onboarding_version == latestOnBoardingVersion) {
                    navigate("/on-boarding");
                    return;
                }

                // For regular returning users: just close modal and stay on current page
                // The SoftwallProvider will detect auth change and unlock automatically
                onClose();
                try {
                    getUserById(data?.session?.user?.id).then(({ success, data }) => {
                      if (success) {
                        dispatch(setUser(data));
                        if (data?.profilePicture) {
                            localStorage.setItem("pdp", data.profilePicture);
                        }
                      } else {
                        // dispatch({
                        //   type: 'RESET_SESSION'
                        // })
                        // dispatch({
                        //   type:'RESET_USER'
                        // })
                        // supabase.auth.signOut()
                      }
                    })
                  } catch (error) {
                    console.error("Error fetching user:", error);
                    }
            } else {
                setLoadingLogin(false);
                setErrorMessage(message)
            }

        })

    };

    const validateCompleteSignup = () => {
        if (!inviteEmail) {
            setErrorMessageSignup("Invite email is missing.");
            return false;
        }
        if (!inviteUsername || !inviteUsername.trim()) {
            setErrorMessageSignup("Username is required.");
            return false;
        }
        if (!(password && password.length > 0)) {
            setErrorMessageSignup("Password is required.");
            return false;
        }
        const passwordRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*\W).{8,}$/;
        if (!passwordRegex.test(password)) {
            setErrorMessageSignup("Password must be at least 8 characters long, with at least 1 uppercase, 1 lowercase, and 1 special character.");
            return false;
        }
        if (pwdConfirm !== password) {
            setErrorMessageSignup("Password confirmation does not match.");
            return false;
        }
        return true;
    };

    const handleCompleteSignup = async () => {
        if (!validateCompleteSignup()) return;
        setLoadingSignup(true);
        setErrorMessageSignup(null);
        try {
            const { success, message } = await completeSignupPassword({
                token: signupToken,
                password,
                passwordVerification: pwdConfirm,
            });
            if (!success) {
                setErrorMessageSignup(message || "Could not complete signup.");
                return;
            }
            const { success: loginSuccess, data, message: loginMessage } = await login({ email: inviteEmail, password });
            if (loginSuccess && data?.session) {
                dispatch(setSessionUser(data.session));
                await supabase.auth.setSession({
                    access_token: data.session.access_token,
                    refresh_token: data.session.refresh_token,
                });
                clearPasswordSetupPending(inviteEmail);
                clearPendingSoftwallInvite();
                const pendingContribute = readPendingContributionIntent();
                const isDigitalOrderIntent =
                    pendingContribute?.source === "order" &&
                    pendingContribute?.creation?.creation_type &&
                    String(pendingContribute.creation.creation_type).toLowerCase().includes("digital");
                if (
                    (pendingContribute?.source === "contribute" || isDigitalOrderIntent) &&
                    Number(pendingContribute?.amount) > 0
                ) {
                    onKeepOpenAfterAuthChange?.(false);
                    onClose();
                    const checkout = await resumePendingContributionCheckout({
                        intent: pendingContribute,
                    });
                    if (checkout?.success && checkout?.redirecting) {
                        return;
                    }
                    window.dispatchEvent(
                        new CustomEvent("hyk:resume-contribution", {
                            detail: pendingContribute,
                        }),
                    );
                    return;
                }
                onKeepOpenAfterAuthChange?.(false);
                onClose();
                const isCreatorSignup =
                    sessionStorage.getItem(SIGNUP_CREATOR_SESSION_KEY) === "1";
                if (isCreatorSignup) {
                    navigate("/add-social-links");
                } else {
                    sessionStorage.removeItem(SIGNUP_CREATOR_SESSION_KEY);
                }
                return;
            }
            setErrorMessageSignup(loginMessage || "Could not log in after signup.");
        } catch (error) {
            console.error("Complete signup failed:", error);
            setErrorMessageSignup(error?.message || "Could not complete signup.");
        } finally {
            setLoadingSignup(false);
        }
    };

    const handleGoogleAuth = async () => {
        setErrorMessage(null);
        setErrorMessageSignup(null);
        setLoadingGoogle(true);
        const nextRoute = `${location.pathname}${location.search || ""}`;
        const result = await startGoogleAuth(nextRoute || "/");
        if (!result.success) {
            if (authMode === "signup") {
                setErrorMessageSignup(result.message);
            } else {
                setErrorMessage(result.message);
            }
            setLoadingGoogle(false);
            return;
        }
        window.location.href = result.url;
    };

    const isGoogleAuthEnabled = import.meta.env.VITE_ENABLE_GOOGLE_AUTH !== "false";

    if (!open) return null;

    return (
        <div className="contribution-section" {...overlayHandlers}>
            <div
                className={`sheet`}
                style={sheetStyle}
                onClick={(e) => e.stopPropagation()}
            >
                <div className="pull-bar" />
                <button
                    type="button"
                    className="softwall-close-btn"
                    onClick={handleCloseAuthModal}
                    aria-label="Close sign up popup"
                >
                    ×
                </button>
                {authMode === "complete-signup" ? (
                    <div className={`auth-container login-animated-container px-16 animate-slide-up`}>
                        <p className="fs-sm2 fw-bold ta-center mb-16 mt-0 mx-16">Create a password</p>
                        <p className="fs-regular fw-regular ta-center fg-hyk-medgrey mb-16 mt-0 px-8">
                            Complete your signup to continue using HYK.
                        </p>
                        <p className="fs-regular fw-regular ta-center fg-red ">{errorMessageSignup}</p>
                        {inviteLoading ? (
                            <p className="ta-center fg-crea">Loading…</p>
                        ) : (
                            <div className="auth-form">
                                <div className="p-relative">
                                    <input
                                        className="input-main w-full mb-8"
                                        placeholder="Password"
                                        type={showPwd ? "text" : "password"}
                                        value={password}
                                        onChange={(e) => {
                                            setErrorMessageSignup(null);
                                            setPassword(e.target.value);
                                        }}
                                    />
                                    <Icon alias={"show-password"} width={24} color="#777777" className={'show-icon'} onClick={() => setShowPwd(prev => !prev)} />
                                </div>
                                <div className="p-relative">
                                    <input
                                        className="input-main w-full mb-8"
                                        placeholder="Password confirmation"
                                        type={showPwd ? "text" : "password"}
                                        value={pwdConfirm}
                                        onChange={(e) => {
                                            setErrorMessageSignup(null);
                                            setPwdConfirm(e.target.value);
                                        }}
                                    />
                                    <Icon alias={"show-password"} width={24} color="#777777" className={'show-icon'} onClick={() => setShowPwd(prev => !prev)} />
                                </div>
                                <button
                                    type="button"
                                    className="btn red-btn btn-full-v"
                                    onClick={handleCompleteSignup}
                                    disabled={loadingSignup || inviteLoading}
                                >
                                    {loadingSignup ? "Signing up..." : "Continue"}
                                </button>
                            </div>
                        )}
                        <button type="button" className="softwall-dismiss-btn mb-40" onClick={handleCloseAuthModal}>Not now</button>
                    </div>
                ) : authMode === "login" ? <div className={`auth-container login-animated-container px-16 animate-slide-up`}>
                    <p className="fs-sm2 fw-bold ta-center mb-16 mt-0 mx-16">
                        {title}
                    </p>
                    <p className="fs-regular fw-regular ta-center fg-red ">{errorMessage}</p>
                    <form onSubmit={handleLogin} className="auth-form">
                        <input
                            ref={(el) => {
                                if (el) {
                                    // Check for auto-filled values on mount and after auto-fill
                                    const checkAutoFill = () => {
                                        if (el.value && el.value !== email) {
                                            setEmail(el.value);
                                        }
                                    };

                                    // Check immediately
                                    checkAutoFill();

                                    // Check after a delay to catch auto-fill
                                    setTimeout(checkAutoFill, 100);
                                    setTimeout(checkAutoFill, 500);
                                    setTimeout(checkAutoFill, 1000);
                                }
                            }}
                            className="input-main"
                            placeholder="Email or username"
                            value={email}
                            onChange={(e) => {
                                setErrorMessage(null)
                                setEmail(e.target.value)
                            }}
                            onFocus={() => {
                                // Force mobile keyboard to open - disabled for Safari iOS
                                // e.target.click();
                                // e.target.focus();
                            }}
                            onTouchStart={() => {
                                // Ensure input is focused on touch - disabled for Safari iOS
                                // e.target.focus();
                            }}
                            onInput={(e) => {
                                // Catch auto-fill events
                                if (e.target.value !== email) {
                                    setEmail(e.target.value);
                                }
                            }}
                            type="text"
                            inputMode="text"
                            autoComplete="email"
                            autoCapitalize="none"
                            autoCorrect="off"
                            spellCheck="false"
                            required
                        />
                        <div className="p-relative">
                            <input
                                ref={(el) => {
                                    if (el) {
                                        // Check for auto-filled values on mount and after auto-fill
                                        const checkAutoFill = () => {
                                            if (el.value && el.value !== password) {
                                                setPassword(el.value);
                                            }
                                        };

                                        // Check immediately
                                        checkAutoFill();

                                        // Check after delays to catch auto-fill
                                        setTimeout(checkAutoFill, 100);
                                        setTimeout(checkAutoFill, 500);
                                        setTimeout(checkAutoFill, 1000);
                                    }
                                }}
                                className="input-main w-full mb-8"
                                placeholder="Password"
                                type={showPwd ? "text" : "password"}
                                value={password}
                                onChange={(e) => {
                                    setErrorMessage(null)
                                    setPassword(e.target.value)
                                }}
                                onFocus={() => {
                                    // Force mobile keyboard to open - disabled for Safari iOS
                                    // e.target.click();
                                    // e.target.focus();
                                }}

                                onInput={(e) => {
                                    // Catch auto-fill events
                                    if (e.target.value !== password) {
                                        setPassword(e.target.value);
                                    }
                                }}
                                inputMode="text"
                                autoComplete="current-password"
                                autoCapitalize="none"
                                autoCorrect="off"
                                spellCheck="false"
                                required
                            />
                            <Icon alias={"show-password"} width={24} color="#777777" className={'show-icon'} onClick={() => setShowPwd(prev => !prev)} />
                        </div>
                        <p className="fg-red-pink fw-bold mt-0 fs-xxs td-underline c-pointer" onClick={() => navigate("/send-recover")}>FORGOT PASSWORD</p>

                        {/* <p className="link-btn mb-16 mt-0" onClick={() => navigate("/send-recover")}>I forgot my password</p> */}
                        <button type="submit" className="btn red-btn btn-full-v" disabled={loadingLogin || loadingGoogle || !!errorMessage}>{loadingLogin ? "Logging in..." : "Log in"}</button>
                        {isGoogleAuthEnabled && (
                            <button
                                type="button"
                                className="btn btn-full-v mt-16 google-auth-btn"
                                onClick={handleGoogleAuth}
                                disabled={loadingLogin || loadingGoogle}
                                aria-label="Continue with Google"
                            >
                                <GoogleButtonContent loading={loadingGoogle} classPrefix="google-auth" />
                            </button>
                        )}
                        {/* <p className="fs-xxs fg-crea fw-medium ta-center mt-8 mb-0">OR CONTINUE WITH</p> */}
                    </form>
                    {/* <div className="social-group">
                                    <button onClick={signInWithGoogle} className="btn red-outline-btn btn-full-v fs-xs mt-24">
                                        <img src="google.png" className={"icon"} width={18} height={18} alt="google" />
                                        Google
                                    </button>
                                    <button onClick={signInWithGoogle} className="btn white-btn btn-full-v fs-xs mt-24">
                                        <img src="facebook.png" className={"icon"} width={18} height={18} alt="facebook" />
                                        Sign up with Facebook
                                    </button>
                                </div> */}
                    <p className="auth-text mb-0 fg-crea fw-medium mt-24">Don't have an account?
                        <button
                            type="button"
                            className="softwall-auth-switch-btn fg-red-pink fw-bold mt-0 fs-xxs td-underline c-pointer"
                            onClick={() => setAuthMode("signup")}
                        >
                            Create an account
                        </button>
                    </p>
                    <button type="button" className="softwall-dismiss-btn mb-40" onClick={handleCloseAuthModal}>Not now</button>

                    {/* {toastMessage && <div className={`toast ${toastType} toast-show`}>{toastMessage}</div>} */}
                </div> :
                    <div className={`auth-container login-animated-container px-16 animate-slide-up`}>
                        {(signupView === "verify-email" || authMode === "verify-email") ? (
                            <div className="softwall-verify-email">
                                <div className="softwall-verify-email-icon-wrap d-flex aic jcc mb-24">
                                    <Icon alias="check-your-email" width={120} height={120} color="#FF3232" />
                                </div>
                                <p className="fs-sm2 fw-bold ta-center mb-8 mt-0 mx-16">
                                    {verifyEmailTitle}
                                </p>
                                <p className="fs-regular fw-regular ta-center fg-hyk-medgrey mb-24 px-8 mt-0">
                                    {verifyEmailMessage ? (
                                        verifyEmailBody
                                    ) : (
                                        <>
                                            We sent an email to{" "}
                                            <span className="fw-bold fg-black">{pendingVerifyEmail}</span>
                                            . Tap the link in the email to confirm your address and continue.
                                        </>
                                    )}
                                </p>
                                <p className="fs-regular fw-regular ta-center fg-red">{errorMessageSignup}</p>
                                { authMode !== "verify-email" &&<button
                                    type="button"
                                    className="btn red-btn btn-full-v mt-8"
                                    onClick={handleCloseAuthModal}
                                    disabled={loadingSignup}
                                >                                    { "Got it"}

                                </button>}
                                {showVerifyEmailActions && (
                                    <div className="softwall-verify-email-links d-flex f-row jcc aic gap-8 mt-16 mb-8">
                                        <button
                                            type="button"
                                            className="link-btn fg-red-pink fw-bold fs-xxs td-underline"
                                            onClick={handleResendInvite}
                                            disabled={loadingSignup}
                                        >
                                            {loadingSignup ? "Sending…" : "Resend email"}
                                        </button>
                                        {/* <span className="fg-hyk-medgrey fs-xxs" aria-hidden="true">
                                            ·
                                        </span> */}
                                        {/* <button
                                            type="button"
                                            className="link-btn fg-red-pink fw-bold fs-xxs td-underline"
                                            onClick={handleChangeEmailClick}
                                            disabled={loadingSignup}
                                        >
                                            Change email
                                        </button> */}
                                    </div>
                                )}
                                <button type="button" className="softwall-dismiss-btn mb-40" onClick={handleCloseAuthModal}>
                                    Not now
                                </button>
                            </div>
                        ) : (
                            <>
                                <p className="fs-sm2 fw-bold ta-center mb-8 mt-0 mx-16">Sign up or Log in</p>
                                <p className="fs-regular fw-regular ta-center fg-dark mb-16 mt-0 px-8">
                                    Create an account to continue using HYK and keep creation alive.
                                </p>
                                <p className="fs-regular fw-regular ta-center fg-red">{errorMessageSignup}</p>

                                <form onSubmit={handleSignup} className="auth-form">
                                    <input
                                        className="input-main mb-8"
                                        placeholder="USERNAME"
                                        value={signupUsername}
                                        onChange={(e) => {
                                            setErrorMessageSignup(null);
                                            setSignupUsername(e.target.value.toUpperCase());
                                        }}
                                        autoComplete="off"
                                        autoCapitalize="characters"
                                        autoCorrect="off"
                                        spellCheck="false"
                                        aria-label="Username"
                                    />
                                    {showEmailField && (
                                        <input
                                            className="input-main mb-16"
                                            placeholder="Email"
                                            value={signupEmail}
                                            onChange={(e) => {
                                                setErrorMessageSignup(null);
                                                setSignupEmail(e.target.value);
                                            }}
                                            type="email"
                                            inputMode="email"
                                            autoComplete="email"
                                            autoCapitalize="none"
                                            autoCorrect="off"
                                            spellCheck="false"
                                            aria-label="Email"
                                        />
                                    )}
                                    {showRoleButtons && (
                                        <div className="softwall-role-picker mb-16" role="group" aria-label="How will you use HYK?">
                                            <div className="d-flex f-row softwall-role-btn-row">
                                                <button
                                                    type="button"
                                                    className={`softwall-role-btn ${signupRole === "fan" ? "is-selected" : ""}`}
                                                    onClick={() => {
                                                        setErrorMessageSignup(null);
                                                        setSignupRole("fan");
                                                    }}
                                                    aria-pressed={signupRole === "fan"}
                                                >
                                                    I am here to explore
                                                </button>
                                                <button
                                                    type="button"
                                                    className={`softwall-role-btn ${signupRole === "creator" ? "is-selected" : ""}`}
                                                    onClick={() => {
                                                        setErrorMessageSignup(null);
                                                        setSignupRole("creator");
                                                    }}
                                                    aria-pressed={signupRole === "creator"}
                                                >
                                                    I am here to create
                                                </button>
                                            </div>
                                        </div>
                                    )}
                                    <p className="fs-xs fg-dark ta-left mt-0 mb-16">
                                        By creating an account, you agree to our <a href="/terms" target="_blank" rel="noreferrer" className="fg-red-pink td-underline">Terms of Use</a>.
                                    </p>
                                    <button
                                        type="submit"
                                        className="btn red-btn btn-full-v mt-8"
                                        disabled={loadingSignup || loadingGoogle}
                                    >
                                        {loadingSignup ? "Signing up…" : "Sign up"}
                                    </button>
                                    {isGoogleAuthEnabled && (
                                        <button
                                            type="button"
                                            className="btn btn-full-v mt-16 softwall-google-btn"
                                            onClick={handleGoogleAuth}
                                            disabled={loadingSignup || loadingGoogle}
                                            aria-label="Continue with Google"
                                        >
                                            <span className="softwall-google-icon"><GoogleMarkIcon /></span>
                                            <span className="softwall-google-label">
                                                {loadingGoogle ? "Redirecting..." : "Continue with Google"}
                                            </span>
                                        </button>
                                    )}
                                </form>
                                <p className="auth-text mb-0 fg-crea fw-medium mt-24 ta-center">
                                    Already have an account?{" "}
                                    {/* Real <button> (not a bare <span>) so Android Chrome reliably treats the tap as an activation (HYK-1136). */}
                                    <button
                                        type="button"
                                        className="softwall-auth-switch-btn fg-red-pink fw-bold mt-0 fs-xxs td-underline c-pointer"
                                        onClick={() => setAuthMode("login")}
                                    >
                                        Log in
                                    </button>
                                </p>
                                <button type="button" className="softwall-dismiss-btn mb-40" onClick={handleCloseAuthModal}>
                                    Not now
                                </button>
                            </>
                        )}
                    </div>}

            </div>
        </div>
    )
}

export default SoftWallModal